import { setFieldValidity } from './functions/utils.functions';
import { AccountCreationForm } from './account';
import { AccountEditionForm } from './edit-account';
import { LoginPasswordForm } from './login';
import { LoginPrecheckForm } from './loginPreCheck';

$(() => {

	// sync with console:/staticContent/assets/js/main.js
	function seasonClassFor(now) {
		let suffix = 'regular'
		if (!now) return `season-${suffix}`;

		const month = now.getMonth();

		if ([6,7].includes(month))
			suffix = 'summer';

		else if ([0, 1, 11].includes(month))
			suffix = 'winter'

		else if (now > new Date(`${now.getFullYear()}-10-20`) && now < new Date(`${now.getFullYear()}-11-03`))
			suffix = 'Halloween'

		else if (now > new Date(`${now.getFullYear()}-09-22`) && now < new Date(`${now.getFullYear()}-12-03`))
			suffix = 'autumn'

		else if ([8].includes(month))
			suffix = 'fall';

		return `season-${suffix.toLowerCase()}`;
	}

	// Season theme
	document.querySelector('.authentication-layout #main')?.classList.add(seasonClassFor(new Date()));

	// Bootstrap
	$('[data-toggle="tooltip"]').tooltip();

	// JQuery Validate defaults
	$.validator.setDefaults({
		errorElement: 'div',
		errorClass: 'form-error',
		validClass: 'form-valid',
		ignore: '.form-ignore-validation',
		errorPlacement: (error, element) => {
			const containerClass = element.is(':checkbox') ? '.form-check' :
				element.is(':radio') ? '.form-radio' : '.form-group';
			element.parents(containerClass).first().find('.form-feedbacks').append(error);
		},
		highlight: (element: HTMLElement, errorClass: string, validClass: string) => {
			setFieldValidity($(element), false);
		},
		success: (($label: JQuery, element: HTMLElement) => {
			setFieldValidity($(element), true);
		})
	});

	// JQuery Validate methods
	$.validator.methods.email = function (value, element) {
		return this.optional(element) || /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(value.toLowerCase());
	};

	$.validator.addMethod('humanname', function (value, element, params) {
		return this.optional(element) || /^[a-zA-Z'\-èéçàùôêîïëüöÈÉÇÀÙÔÊÎÏËÜÖ\s]*$/g.test(value);
	});

	$.validator.addMethod('phone', function (value, element, params) {
		return this.optional(element) || /^((\+){1})?(\(\+[0-9]+\){1})?[0-9]+$/g.test(value);
	});

	$.validator.addMethod('lowercaseChar', function (value, element, params) {
		return this.optional(element) || /[a-z]+/g.test(value);
	});

	$.validator.addMethod('uppercaseChar', function (value, element, params) {
		return this.optional(element) || /[A-Z]+/g.test(value);
	});

	$.validator.addMethod('digitChar', function (value, element, params) {
		return this.optional(element) || /[0-9]+/g.test(value);
	});

	$.validator.addMethod('specialChar', function (value, element, params) {
		return this.optional(element) || /[!@#$€~%^&*(),.?":{}|<>[\]\-_]+/g.test(value);
	});

	// Account creation page
	if ($('#account-creation-page').length) {
		const accountCreationForm = new AccountCreationForm();
		accountCreationForm.init();
	}
	// Account edition page
	else if ($('#account-edition-form').length) {
		const accountEditionForm = new AccountEditionForm();
		accountEditionForm.init();
	}
	// Login page
	else if ($('#login-form').length) {
		const loginForm = new LoginPrecheckForm();
		loginForm.init();
	}
	// Password-Login page
	else if ($('#login-password-form').length) {
		const loginPasswordForm = new LoginPasswordForm();
		loginPasswordForm.init();
	}
});
